module.exports = __webpack_public_path__ + "static/media/signInBG.76d2eaad.png";